import { render } from "./RemoveProfileImage.vue?vue&type=template&id=19922384&scoped=true&lang=pug"
import script from "./RemoveProfileImage.vue?vue&type=script&lang=js"
export * from "./RemoveProfileImage.vue?vue&type=script&lang=js"

import "./RemoveProfileImage.vue?vue&type=style&index=0&id=19922384&scoped=true&lang=scss"
import "./RemoveProfileImage.vue?vue&type=style&index=1&id=19922384&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19922384"]])

export default __exports__